// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "backend/v1/assistant.proto" (package "backend.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { SaveFamilyResponse } from "./family";
import { PlanJob } from "./plan";
import { DecisionTool } from "./plan";
import { Date } from "../../core/v1/date";
import { Struct } from "../../google/protobuf/struct";
import { Timestamp } from "../../google/protobuf/timestamp";
// AbiChat (docs/design/abichat-redesign.md): a conversation between the signed-in user and the model,
// in which the model can call tools. A turn is a list of typed blocks, and the app picks how to draw a
// block from its type, never from its text: the model's own words are only ever `text` blocks, so it
// can't produce a card. Conversations are kept ASSISTANT_RETENTION_DAYS after their last message.

/**
 * @generated from protobuf message backend.v1.AssistantConversation
 */
export interface AssistantConversation {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 3;
     */
    expiresAt?: Timestamp; // moves on with every message
    /**
     * @generated from protobuf field: repeated backend.v1.AssistantTurn turns = 4;
     */
    turns: AssistantTurn[];
}
/**
 * @generated from protobuf message backend.v1.AssistantTurn
 */
export interface AssistantTurn {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: backend.v1.AssistantTurn.Role role = 2;
     */
    role: AssistantTurn_Role;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: repeated backend.v1.AssistantBlock blocks = 4;
     */
    blocks: AssistantBlock[];
}
/**
 * @generated from protobuf enum backend.v1.AssistantTurn.Role
 */
export enum AssistantTurn_Role {
    /**
     * @generated from protobuf enum value: ROLE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ROLE_USER = 1;
     */
    USER = 1,
    /**
     * @generated from protobuf enum value: ROLE_ASSISTANT = 2;
     */
    ASSISTANT = 2
}
/**
 * @generated from protobuf message backend.v1.AssistantBlock
 */
export interface AssistantBlock {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string; // a later reply can update the block (a simulation finishing, a draft applied)
    /**
     * @generated from protobuf oneof: block
     */
    block: {
        oneofKind: "text";
        /**
         * @generated from protobuf field: backend.v1.AssistantText text = 2;
         */
        text: AssistantText;
    } | {
        oneofKind: "card";
        /**
         * @generated from protobuf field: backend.v1.AssistantCard card = 3;
         */
        card: AssistantCard;
    } | {
        oneofKind: "simulation";
        /**
         * @generated from protobuf field: backend.v1.AssistantSimulation simulation = 4;
         */
        simulation: AssistantSimulation;
    } | {
        oneofKind: "action";
        /**
         * @generated from protobuf field: backend.v1.AssistantAction action = 5;
         */
        action: AssistantAction;
    } | {
        oneofKind: "draft";
        /**
         * @generated from protobuf field: backend.v1.AssistantDraft draft = 6;
         */
        draft: AssistantDraft;
    } | {
        oneofKind: "notice";
        /**
         * @generated from protobuf field: backend.v1.AssistantNotice notice = 7;
         */
        notice: AssistantNotice;
    } | {
        oneofKind: undefined;
    };
}
/**
 * In a user turn, what they typed; in an assistant turn, what the model wrote (AI, may be wrong).
 *
 * @generated from protobuf message backend.v1.AssistantText
 */
export interface AssistantText {
    /**
     * @generated from protobuf field: string text = 1;
     */
    text: string;
}
/**
 * A tool's result, shown as it came from the tool. `data` is the tool's output (the shapes are in
 * plan-logic/assistant/cards.ts, by `kind`), the same object the model was given.
 *
 * @generated from protobuf message backend.v1.AssistantCard
 */
export interface AssistantCard {
    /**
     * @generated from protobuf field: string kind = 1;
     */
    kind: string; // the tool that made it, e.g. "get_plan_overview"
    /**
     * @generated from protobuf field: backend.v1.AssistantTier tier = 2;
     */
    tier: AssistantTier;
    /**
     * @generated from protobuf field: string title = 3;
     */
    title: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 4;
     */
    data?: Struct;
    /**
     * @generated from protobuf field: int32 family_version = 5;
     */
    familyVersion: number; // the family version it was read from (0 for reviewed content)
    /**
     * @generated from protobuf field: core.v1.Date as_of = 6;
     */
    asOf?: Date; // the plan's start date, for calculated cards
}
/**
 * A what-if run through the Decisions pipeline (a Scenario row and job). The app polls the scenario
 * and, when its job has finished, reports it (POST .../simulations/:scenario/finished).
 *
 * @generated from protobuf message backend.v1.AssistantSimulation
 */
export interface AssistantSimulation {
    /**
     * @generated from protobuf field: string scenario_uuid = 1;
     */
    scenarioUuid: string;
    /**
     * @generated from protobuf field: backend.v1.DecisionTool tool = 2;
     */
    tool: DecisionTool;
    /**
     * @generated from protobuf field: string title = 3;
     */
    title: string; // the scenario's auto-title
    /**
     * @generated from protobuf field: repeated string simulated = 4;
     */
    simulated: string[]; // what was simulated, a line each, from the saved inputs (not the model)
    /**
     * @generated from protobuf field: backend.v1.AssistantSimulation.State state = 5;
     */
    state: AssistantSimulation_State;
    /**
     * @generated from protobuf field: google.protobuf.Struct summary = 6;
     */
    summary?: Struct; // when done: the verdict and its facts (plan-logic/assistant)
    /**
     * @generated from protobuf field: string error_message = 7;
     */
    errorMessage: string; // when failed, user-safe
    /**
     * @generated from protobuf field: int32 family_version = 8;
     */
    familyVersion: number;
    /**
     * @generated from protobuf field: string href = 9;
     */
    href: string; // the scenario in its Decisions tool
}
/**
 * @generated from protobuf enum backend.v1.AssistantSimulation.State
 */
export enum AssistantSimulation_State {
    /**
     * @generated from protobuf enum value: STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: STATE_RUNNING = 1;
     */
    RUNNING = 1,
    /**
     * @generated from protobuf enum value: STATE_DONE = 2;
     */
    DONE = 2,
    /**
     * @generated from protobuf enum value: STATE_FAILED = 3;
     */
    FAILED = 3
}
/**
 * Something for the app to do: offer a button, or (`go`) do it now.
 *
 * @generated from protobuf message backend.v1.AssistantAction
 */
export interface AssistantAction {
    /**
     * @generated from protobuf field: backend.v1.AssistantAction.Kind kind = 1;
     */
    kind: AssistantAction_Kind;
    /**
     * @generated from protobuf field: string label = 2;
     */
    label: string; // the button's text
    /**
     * @generated from protobuf field: string href = 3;
     */
    href: string; // an in-app path from the tools' allow-list
    /**
     * @generated from protobuf field: bool go = 4;
     */
    go: boolean;
    /**
     * @generated from protobuf field: string message = 5;
     */
    message: string;
}
/**
 * @generated from protobuf enum backend.v1.AssistantAction.Kind
 */
export enum AssistantAction_Kind {
    /**
     * @generated from protobuf enum value: KIND_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * open `href`
     *
     * @generated from protobuf enum value: KIND_NAVIGATE = 1;
     */
    NAVIGATE = 1,
    /**
     * open `href` and play that page's guide
     *
     * @generated from protobuf enum value: KIND_PAGE_GUIDE = 2;
     */
    PAGE_GUIDE = 2,
    /**
     * open the contact form with `message` filled in
     *
     * @generated from protobuf enum value: KIND_CONTACT_SUPPORT = 3;
     */
    CONTACT_SUPPORT = 3
}
/**
 * A drafted change to the household's data. Only the user's Apply (POST /assistant/drafts/:uuid/apply)
 * saves it; nothing the model says or does can.
 *
 * @generated from protobuf message backend.v1.AssistantDraft
 */
export interface AssistantDraft {
    /**
     * @generated from protobuf field: string draft_uuid = 1;
     */
    draftUuid: string;
    /**
     * @generated from protobuf field: backend.v1.AssistantDraft.State state = 2;
     */
    state: AssistantDraft_State;
    /**
     * @generated from protobuf field: repeated backend.v1.AssistantDraft.Change changes = 3;
     */
    changes: AssistantDraft_Change[];
    /**
     * @generated from protobuf field: int32 family_version = 4;
     */
    familyVersion: number; // the version it was drafted against
    /**
     * @generated from protobuf field: backend.v1.PlanJob job = 5;
     */
    job?: PlanJob; // the plan job the save started, once applied
}
/**
 * @generated from protobuf message backend.v1.AssistantDraft.Change
 */
export interface AssistantDraft_Change {
    /**
     * @generated from protobuf field: string label = 1;
     */
    label: string; // what changes, e.g. "Your salary (Acme)"
    /**
     * @generated from protobuf field: string before = 2;
     */
    before: string; // as shown, e.g. "$85,000 a year"; empty for something new
    /**
     * @generated from protobuf field: string after = 3;
     */
    after: string; // as shown; empty for something removed
}
/**
 * @generated from protobuf enum backend.v1.AssistantDraft.State
 */
export enum AssistantDraft_State {
    /**
     * @generated from protobuf enum value: STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: STATE_APPLIED = 2;
     */
    APPLIED = 2,
    /**
     * @generated from protobuf enum value: STATE_DISCARDED = 3;
     */
    DISCARDED = 3,
    /**
     * the family changed since it was drafted; draft it again
     *
     * @generated from protobuf enum value: STATE_STALE = 4;
     */
    STALE = 4
}
/**
 * A message from the app itself, not the model: a limit reached, the model unavailable.
 *
 * @generated from protobuf message backend.v1.AssistantNotice
 */
export interface AssistantNotice {
    /**
     * @generated from protobuf field: string text = 1;
     */
    text: string;
}
/**
 * POST /api/assistant/messages
 *
 * @generated from protobuf message backend.v1.SendAssistantMessageRequest
 */
export interface SendAssistantMessageRequest {
    /**
     * @generated from protobuf field: string conversation_uuid = 1;
     */
    conversationUuid: string; // empty starts a new conversation
    /**
     * @generated from protobuf field: string text = 2;
     */
    text: string;
    /**
     * @generated from protobuf field: string page = 3;
     */
    page: string; // the app path the user is on (context for the model)
}
/**
 * The answer to a message or a finished simulation: the turns it added, and earlier blocks it changed.
 *
 * @generated from protobuf message backend.v1.AssistantReply
 */
export interface AssistantReply {
    /**
     * @generated from protobuf field: string conversation_uuid = 1;
     */
    conversationUuid: string;
    /**
     * @generated from protobuf field: repeated backend.v1.AssistantTurn turns = 2;
     */
    turns: AssistantTurn[];
    /**
     * @generated from protobuf field: repeated backend.v1.AssistantBlock updated_blocks = 3;
     */
    updatedBlocks: AssistantBlock[];
}
/**
 * POST /api/assistant/drafts/:uuid/apply
 *
 * @generated from protobuf message backend.v1.ApplyAssistantDraftRequest
 */
export interface ApplyAssistantDraftRequest {
    /**
     * @generated from protobuf field: int32 expected_version = 1;
     */
    expectedVersion: number; // the family version the user saw (409 when it moved on)
}
/**
 * @generated from protobuf message backend.v1.ApplyAssistantDraftResponse
 */
export interface ApplyAssistantDraftResponse {
    /**
     * @generated from protobuf field: backend.v1.AssistantBlock block = 1;
     */
    block?: AssistantBlock; // the draft, applied
    /**
     * @generated from protobuf field: backend.v1.SaveFamilyResponse saved = 2;
     */
    saved?: SaveFamilyResponse; // as POST /family/questionnaire answers
}
/**
 * How a card's content was made.
 *
 * @generated from protobuf enum backend.v1.AssistantTier
 */
export enum AssistantTier {
    /**
     * @generated from protobuf enum value: ASSISTANT_TIER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * from the engine's plan or the household's stored data
     *
     * @generated from protobuf enum value: ASSISTANT_TIER_CALCULATED = 1;
     */
    CALCULATED = 1,
    /**
     * reviewed content shown word for word (the FAQ)
     *
     * @generated from protobuf enum value: ASSISTANT_TIER_REVIEWED = 2;
     */
    REVIEWED = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class AssistantConversation$Type extends MessageType<AssistantConversation> {
    constructor() {
        super("backend.v1.AssistantConversation", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "turns", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AssistantTurn }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.AssistantConversation
 */
export const AssistantConversation = new AssistantConversation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantTurn$Type extends MessageType<AssistantTurn> {
    constructor() {
        super("backend.v1.AssistantTurn", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "role", kind: "enum", T: () => ["backend.v1.AssistantTurn.Role", AssistantTurn_Role, "ROLE_"] },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "blocks", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AssistantBlock }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.AssistantTurn
 */
export const AssistantTurn = new AssistantTurn$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantBlock$Type extends MessageType<AssistantBlock> {
    constructor() {
        super("backend.v1.AssistantBlock", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "text", kind: "message", oneof: "block", T: () => AssistantText },
            { no: 3, name: "card", kind: "message", oneof: "block", T: () => AssistantCard },
            { no: 4, name: "simulation", kind: "message", oneof: "block", T: () => AssistantSimulation },
            { no: 5, name: "action", kind: "message", oneof: "block", T: () => AssistantAction },
            { no: 6, name: "draft", kind: "message", oneof: "block", T: () => AssistantDraft },
            { no: 7, name: "notice", kind: "message", oneof: "block", T: () => AssistantNotice }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.AssistantBlock
 */
export const AssistantBlock = new AssistantBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantText$Type extends MessageType<AssistantText> {
    constructor() {
        super("backend.v1.AssistantText", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.AssistantText
 */
export const AssistantText = new AssistantText$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantCard$Type extends MessageType<AssistantCard> {
    constructor() {
        super("backend.v1.AssistantCard", [
            { no: 1, name: "kind", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tier", kind: "enum", T: () => ["backend.v1.AssistantTier", AssistantTier, "ASSISTANT_TIER_"] },
            { no: 3, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "data", kind: "message", T: () => Struct },
            { no: 5, name: "family_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "as_of", kind: "message", T: () => Date }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.AssistantCard
 */
export const AssistantCard = new AssistantCard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantSimulation$Type extends MessageType<AssistantSimulation> {
    constructor() {
        super("backend.v1.AssistantSimulation", [
            { no: 1, name: "scenario_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tool", kind: "enum", T: () => ["backend.v1.DecisionTool", DecisionTool, "DECISION_TOOL_"] },
            { no: 3, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "simulated", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "state", kind: "enum", T: () => ["backend.v1.AssistantSimulation.State", AssistantSimulation_State, "STATE_"] },
            { no: 6, name: "summary", kind: "message", T: () => Struct },
            { no: 7, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "family_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "href", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.AssistantSimulation
 */
export const AssistantSimulation = new AssistantSimulation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantAction$Type extends MessageType<AssistantAction> {
    constructor() {
        super("backend.v1.AssistantAction", [
            { no: 1, name: "kind", kind: "enum", T: () => ["backend.v1.AssistantAction.Kind", AssistantAction_Kind, "KIND_"] },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "href", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "go", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.AssistantAction
 */
export const AssistantAction = new AssistantAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantDraft$Type extends MessageType<AssistantDraft> {
    constructor() {
        super("backend.v1.AssistantDraft", [
            { no: 1, name: "draft_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state", kind: "enum", T: () => ["backend.v1.AssistantDraft.State", AssistantDraft_State, "STATE_"] },
            { no: 3, name: "changes", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AssistantDraft_Change },
            { no: 4, name: "family_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "job", kind: "message", T: () => PlanJob }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.AssistantDraft
 */
export const AssistantDraft = new AssistantDraft$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantDraft_Change$Type extends MessageType<AssistantDraft_Change> {
    constructor() {
        super("backend.v1.AssistantDraft.Change", [
            { no: 1, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "before", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "after", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.AssistantDraft.Change
 */
export const AssistantDraft_Change = new AssistantDraft_Change$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantNotice$Type extends MessageType<AssistantNotice> {
    constructor() {
        super("backend.v1.AssistantNotice", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.AssistantNotice
 */
export const AssistantNotice = new AssistantNotice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendAssistantMessageRequest$Type extends MessageType<SendAssistantMessageRequest> {
    constructor() {
        super("backend.v1.SendAssistantMessageRequest", [
            { no: 1, name: "conversation_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.SendAssistantMessageRequest
 */
export const SendAssistantMessageRequest = new SendAssistantMessageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantReply$Type extends MessageType<AssistantReply> {
    constructor() {
        super("backend.v1.AssistantReply", [
            { no: 1, name: "conversation_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "turns", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AssistantTurn },
            { no: 3, name: "updated_blocks", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AssistantBlock }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.AssistantReply
 */
export const AssistantReply = new AssistantReply$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApplyAssistantDraftRequest$Type extends MessageType<ApplyAssistantDraftRequest> {
    constructor() {
        super("backend.v1.ApplyAssistantDraftRequest", [
            { no: 1, name: "expected_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.ApplyAssistantDraftRequest
 */
export const ApplyAssistantDraftRequest = new ApplyAssistantDraftRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApplyAssistantDraftResponse$Type extends MessageType<ApplyAssistantDraftResponse> {
    constructor() {
        super("backend.v1.ApplyAssistantDraftResponse", [
            { no: 1, name: "block", kind: "message", T: () => AssistantBlock },
            { no: 2, name: "saved", kind: "message", T: () => SaveFamilyResponse }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.ApplyAssistantDraftResponse
 */
export const ApplyAssistantDraftResponse = new ApplyAssistantDraftResponse$Type();
